/* eslint-disable */
var CodeService = function(resource) {
    this.resource = resource;
    this.map = {};
};

CodeService.prototype.get = function(path, param) {
    return new Promise(resolve => {
        if (this.map[path]) {
            resolve(this.map[path]);
        } else {
            this.resource
                .get(`/api/code${path}`, param)
                .then(response => {
                    this.map[path] = response.data;
                    return resolve(this.map[path]);
                })
                .catch(error => {
                    this.map[path] = [];
                    return resolve(this.map[path]);
                });
        }
    });
};

CodeService.prototype.post = function(path, param, key) {
    return new Promise(resolve => {
        if (this.map[key]) {
            resolve(this.map[key]);
        } else {
            this.resource
                .post(`/api/code${path}`, param)
                .then(response => {
                    this.map[key] = response.data;
                    return resolve(this.map[key]);
                })
                .catch(error => {
                    this.map[key] = [];
                    return resolve(this.map[key]);
                });
        }
    });
};

CodeService.prototype.find = function(param, value) {
    if (this.map[param]) {
        var _f = this.map[param].filter(x => x.code === value)[0];
        return _f || {};
    } else {
        return {};
    }
};

CodeService.prototype.findName = function(param, value) {
    if (typeof param === "string") {
        return this.find(param, value).name || value;
    } else if (Array.isArray(param)) {
        var _f = param.filter(x => x.code === value)[0];
        return (_f || {}).name || value;
    }
    return value;
};

export default CodeService;